import { useEffect, useState } from "react";
import { NotebookPen } from "lucide-react";
import { api } from "@/lib/api";
import { Chip, Empty, PageHeader, Spinner } from "@/components/rp";
import { Diario } from "@/components/Diario";

export default function ClientDiario() {
  const [orders, setOrders] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    api.get("/client/orders").then((r) => { setOrders(r.data); setSel(r.data[0]?.id || null); }).catch(() => setOrders([]));
  }, []);
  if (!orders) return <Spinner />;
  return (
    <div className="max-w-6xl" data-testid="client-diario-page">
      <PageHeader label="Diario di bordo" title="Cosa succede in cantiere" />
      <p className="text-sm text-[#757575] -mt-5 mb-6">Ogni giorno lo staff registra le attività svolte, con le foto. Scegli un giorno nel calendario e, se hai dubbi, fai una domanda sulla giornata.</p>
      {!orders.length && <Empty icon={NotebookPen} title="Nessun cantiere" text="Il diario sarà disponibile all'apertura del cantiere." />}
      {orders.length > 1 && (
        <div className="flex flex-wrap gap-2 mb-5" data-testid="client-diario-orders">
          {orders.map((o) => <Chip key={o.id} active={sel === o.id} onClick={() => setSel(o.id)} data-testid={`client-diario-order-${o.id}`}>{o.title}</Chip>)}
        </div>
      )}
      {sel && <div className="rp-card p-5"><Diario key={sel} oid={sel} bare /></div>}
    </div>
  );
}
